export default __webpack_public_path__ + "static/media/Page20.f1c1a09e.txt";